import { M8PartnerInfo, M8PartnerDTO } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendHeadersWithJSONContentType, customFetch } from 'utils/http';

export const updatePartnerInfo = async (
  params: M8PartnerInfo
): Promise<M8PartnerDTO> => {
  const fetchURL = getM8PartnerURL('updatePartnerInfo');

  const body = JSON.stringify(params);

  const headers = new Headers();

  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(fetchURL, {
    method: 'PUT',
    body,
    headers,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
